import React from 'react';
import { pick, prop } from 'ramda';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import { Icon } from 'js/components/common/Icon';
import { BackboneReplacer } from 'js/backbone/components/BackboneReplacer';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import { Link } from 'js/components/common/Link';

import style from './MyBonuses.scss';
import bonusStyle from '../../BonusElements.scss';

export const MyBonuses: React.FC = () => {
    const translate = useComponentTranslations();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const { dynamicTags, rootPage } = useAppSelector(pick(['dynamicTags', 'rootPage']));
    const myPromotionsPage = dynamicTags && dynamicTags.DTAG_MYPROMOTIONSPAGE || rootPage;

    return <Link
                href={myPromotionsPage}
                className={style.myBonus}
                aria-label={translate('header.myBonusesBtn')}
            >
                {isDesktop ? (
                    <div className={style.desktopBonusItem}>
                        <Icon type="bonus" className={`${style.bonusIcon} cms-icon-bonus`}/>
                        <div className={bonusStyle.counterContainer}>
                            <BackboneReplacer
                                viewName="bonuscounter"
                                dynamicName="BONUS_COUNTER"
                            />
                        </div>
                    </div>
                    ) : (
                    <div className={style.bonusItem}>
                            <div className={bonusStyle.counterContainer}>
                                <BackboneReplacer dynamicName="BONUS_COUNTER" viewName="bonuscounter"/>
                            </div>
                        <span className={style.bonusImgContainer}></span>
                    </div>)}
            </Link>;
};
